import GeospatialMapLayerType from "./geospatialMapLayerType";

const getGeospatialMapLayerTypeDisplayName = (
  geospatialMapLayerType: GeospatialMapLayerType,
) => {
  if (geospatialMapLayerType === GeospatialMapLayerType.XyzTiles) {
    return "XYZ Tiles";
  }

  return "";
};

const getGeospatialXyzTilesLayerSampleUrl = () => {
  return "http://example.com/{z}/{x}/{y}.png";
};

const geospatialMapLayerTypeHelper = {
  getGeospatialMapLayerTypeDisplayName,
  getGeospatialXyzTilesLayerSampleUrl,
};

export default geospatialMapLayerTypeHelper;
